module.exports = function findFileFieldName(media_rel) {
	let rels = media_rel && media_rel.relationships ? media_rel.relationships : null;
	if (rels) {
		for (const [field_name, field_data] of Object.entries(rels)) {
			if (field_name.includes("field_")) {
				if (field_data && field_data.data && field_data.data.type === "file--file") {
					return field_name;
				}
			}
		}
	}
	return null;
};
